import { Dispatch, SetStateAction, createContext } from 'react';

import { EventType } from '../../types/module';

export interface DropdownContextType {
  open?: boolean;
  setOpen?: Dispatch<SetStateAction<boolean>>;
  toggle?: (event: EventType) => void;
  activedescendant?: string;
  changeActiveDescendant?: (event: EventType) => void;
  refDropdown?: HTMLElement;
}

export const DropdownContext = createContext<DropdownContextType>({
  open: false,
});
